import * as React from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import { JRCTypography } from '../../../../JRCTypography/JRCTypography';

export const EditorInplace = styled.div<{ color?: string; linkColor?: string; fontSize?: string }>`
    font-size: ${(props) => (props.fontSize ? props.fontSize : 18)}px;
    color: ${(props) => (props.color ? props.color : props.theme.color.grey5)};
    width: 100%;
    box-sizing: border-box;
    box-shadow: none;
    cursor: text;

    .ProseMirror {
        margin: 16px 0;
        a {
            color: ${(props) => (props.linkColor ? props.linkColor : props.theme.color.secondary)}!important;
        }
        a span {
            color: ${(props) => (props.linkColor ? props.linkColor : props.theme.color.secondary)}!important;
        }
    }

    .ProseMirror p.is-empty::before {
        font-size: ${(props) => (props.fontSize ? props.fontSize : 18)}px;
        color: #adb5bd;
        content: attr(data-placeholder);
        float: left;
        height: 0;
        pointer-events: none;
    }

    ul,
    ol {
        margin: 16px;
    }

    a {
        color: ${(props) => (props.linkColor ? props.linkColor : props.theme.color.secondary)}!important;
    }
    a span {
        color: ${(props) => (props.linkColor ? props.linkColor : props.theme.color.secondary)}!important;
    }
`;

export const Editor = styled.div`
    color: ${(props) => props.theme.color.grey5};
    border: 1px solid ${(props) => props.theme.color.grey2};
    width: 100%;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 0;
    margin-bottom: 4px;
    box-shadow: none;
    transition: border 0.2s, box-shadow 0.2s;
    cursor: text;
    z-index: 100;

    &:hover {
        box-shadow: 0 0 2px ${(props) => props.theme.color.grey2};
    }
    &:focus-within {
        border-color: ${(props) => props.theme.color.navy};
        box-shadow: 0 0 2px ${(props) => props.theme.color.grey4};
    }

    .ProseMirror {
        margin: 16px;
        min-height: 72px;
    }

    ul,
    ol {
        margin: 16px;
    }

    a {
        color: blue;
    }
`;

export const CharactersCount = styled(JRCTypography)`
    color: ${(props) => props.theme.color.grey4};
    margin: 8px 8px 12px 16px;
`;

const StyledSelect = styled(Select)`
    display: inline-flex;

    && input {
        border: none !important;
        width: 88px !important;
        margin: 0 -8px !important;
        box-shadow: none !important;
    }

    && input:hover,
    && input:focus {
        box-shadow: none !important;
    }

    && input + div {
        right: 0;
    }

    .option-menu {
        min-width: unset;
    }
`;

const DEFAULT_FONT_SIZE = { label: '14px', size: 14 };

const FONT_SIZES = [
    {
        label: '12px',
        size: 12,
    },
    DEFAULT_FONT_SIZE,
    {
        label: '18px',
        size: 18,
    },
    {
        label: '24px',
        size: 24,
    },
];

export function FontSizeSelect(props: { onChange: (size: number) => void }) {
    const [fontSize, setFontSize] = React.useState<{ label: string; size: number }>(
        FONT_SIZES.find((f) => f.label === 'Moyen') || DEFAULT_FONT_SIZE,
    );

    function onChange(fontSize: { label: string; size: number }) {
        setFontSize(fontSize);
        props.onChange(fontSize?.size || 14);
    }

    return (
        <StyledSelect
            options={FONT_SIZES}
            getLabel={(o: any) => o.label}
            onChange={onChange}
            value={fontSize as never}
            name={null as never}
            ref={null as any}
            hideDeleteIcon
        />
    );
}

export const FixedMenuWrapper = styled.div`
    position: fixed;
    top: 90px;
    left: 0;
    background-color: ${(props) => props.theme.color.grey0};
    width: 100%;
    height: 50px;
    justify-content: center;
    align-items: center;
    display: flex;
    border-bottom: 1px solid ${(props) => props.theme.color.grey1};
`;

export const MenuWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    row-gap: 4px;
    padding: 0 8px;
    background-color: ${(props) => props.theme.color.grey0};
    border-bottom: 1px solid ${(props) => props.theme.color.grey2};
    border-radius: 8px 8px 0 0;
`;

export const Spacer = styled.div`
    width: 1px;
    height: 24px;
    margin: 0 8px;
    background-color: ${(props) => props.theme.color.grey2};
`;

const LabelColor = styled.label<{ color: string }>`
    display: inline-block;
    clip-path: circle(45%);
    width: 18px;
    height: 18px;
    margin: 11px;
    cursor: pointer;
    background-color: black;
    background-color: ${(props) => props.color};
`;

const InputColor = styled.input`
    && {
        opacity: 0;
        position: absolute;
        pointer-events: none;
    }
`;

export const ReadOnlyBorder = styled.div`
    padding: 8px 16px;
    border: 1px solid ${(props) => props.theme.color.grey1};
    border-radius: 8px;
    min-height: 40px;

    a {
        color: ${(props) => props.theme.color.secondary};
    }
`;

export function SimpleInputColor(props: React.ComponentPropsWithoutRef<'input'>) {
    return (
        <LabelColor color={props.value as string}>
            <InputColor {...props} type="color" />
        </LabelColor>
    );
}
